






















import { Component, Vue } from 'vue-property-decorator';
import superAdminGuard from '@/guards/super-admin-guard';

@Component({
  beforeRouteEnter(to, from, next) {
    superAdminGuard(to, from, next).catch(router => {
      router.push({ name: 'Dashboard' });
      router.app.$sMessage.error(router.app.$t('noPermissions'));
    });
  },
})
export default class Main extends Vue {
}
